/* eslint-disable no-useless-escape */
import React, { useEffect, useContext } from "react"
import styles from "./index.module.scss"
import SwitchComponent from "../../../../atoms/Switch"
import Input from "../../../../atoms/Input"
import Radio from "../../../../atoms/Radio"
import intl from "react-intl-universal"
import { WestgardRulesContext } from "../../../../../contexts/Equipments"

export const MaximunImprecisun = ({
  cJustify,
  cTextAmount,
  bIsError,
  bActiveMaximumInaccuracy,
  biologicalVariation,
  manualImprecisium,
  setCJustify,
  setCTextAmount,
  setBIsError,
  setBActiveMaximumInaccuracy,
  setIsChanged,
  setBiologicalVariation,
  setManualImprecisium,
}) => {
  const { dataConfigAnalyte, setDataConfigAnalyte, isSigma } = useContext(WestgardRulesContext)

  useEffect(() => {
    if (dataConfigAnalyte.eqpanlt_cjustification) {
      setCJustify(dataConfigAnalyte.eqpanlt_cjustification.trim())
      setCTextAmount(String(dataConfigAnalyte.eqpanlt_nimprecision_value).trim())
    }
  }, [bActiveMaximumInaccuracy])

  useEffect(() => {
    if (!dataConfigAnalyte.eqpanlt_eimprecision_type) return
    if (dataConfigAnalyte.eqpanlt_eimprecision_type === "MANUAL") {
      setBiologicalVariation(false)
      setManualImprecisium(true)
    } else {
      setBiologicalVariation(true)
      setManualImprecisium(false)
    }
  }, [])

  useEffect(() => {
    if (isSigma === true) {
      setBActiveMaximumInaccuracy(true)
      setBiologicalVariation(true)
      setManualImprecisium(false)
    }
  }, [isSigma])

  return (
    <div className={styles.flexStart}>
      <div className={styles.containerContent}>
        <div className={styles.flexStart}>
          <h1 className={styles.title}>
            {intl.get("ciq.create_analytes.m_imprecisium")}
          </h1>
          <SwitchComponent
            cSizeFont="3rem !important"
            bg="transparent"
            width="40px"
            border="none"
            onClick={() => {
              setBActiveMaximumInaccuracy(!bActiveMaximumInaccuracy)
              setIsChanged(true)
            }}
            value={bActiveMaximumInaccuracy}
          />
        </div>
        <div
          className={`${styles.flexStart} ${
            bActiveMaximumInaccuracy ? "" : styles.opacity
          }`}
          style={{ alignItems: "end" }}
        >
          <Radio
            label={intl.get("ciq.header_table_list_analyte.variation_biologic") + ":"}
            checked={biologicalVariation}
            disabled={
              !bActiveMaximumInaccuracy || dataConfigAnalyte?.eqpanlt?.anlt_biovar === null
            }
            onClick={() => {
              setBiologicalVariation(true)
              setManualImprecisium(false)
              setIsChanged(true)
              setBIsError({
                ...bIsError,
                bIsErrorAmount: false,
                bIsErrorJustify: false,
              })
            }}
          />

          <div
            className={styles.itemFlex}
            style={{
              width: "100%",
            }}
          >
            {dataConfigAnalyte.eqpanlt?.anlt_biovar?.biological_variation_summary ||
            dataConfigAnalyte?.eqpanlt_anlt?.anlt_biovar?.biological_variation_summary}
          </div>
        </div>
        <div
          className={`${styles.flexStart} ${
            bActiveMaximumInaccuracy ? "" : styles.opacity
          }`}
        >
          <Radio
            label={intl.get("ciq.manual_imprecision") + ":"}
            checked={manualImprecisium}
            disabled={!bActiveMaximumInaccuracy}
            onClick={() => {
              setBiologicalVariation(false)
              setManualImprecisium(true)
            }}
          />

          <div
            className={`${styles.itemFlex} ${
              bIsError.bIsErrorAmount ? styles.error : ""
            } ${
              bActiveMaximumInaccuracy && !biologicalVariation ? "" : styles.opacity
            }  `}
            style={{
              width: "14rem",
            }}
          >
            <Input
              label={intl.get("amount") + "*"}
              width="100%"
              disabled={!bActiveMaximumInaccuracy || biologicalVariation}
              value={
                bActiveMaximumInaccuracy && biologicalVariation ? "---" : cTextAmount
              }
              onChange={(e) => {
                let value = e.target.value.trim()
                value = value.replace(/[^0-9,\.]/g, "")

                value = value.replace(/(\..*)\./g, "$1")

                value = value.replace(/(,.*)\,/g, "$1")
                setCTextAmount(value)

                if (!e.target.value !== "") {
                  setBIsError({
                    ...bIsError,
                    bIsErrorAmount: false,
                  })
                }

                const newDataConfig = {
                  ...dataConfigAnalyte,
                  eqpanlt_nimprecision_value: value,
                }
                setIsChanged(true)

                setDataConfigAnalyte(newDataConfig)
              }}
            />
            <small style={{ color: "red", opacity: bIsError.bIsErrorAmount ? 1 : 0 }}>
              {intl.get("form.required_field")}
            </small>
          </div>
          <div
            className={`${styles.itemFlex} ${
              bIsError.bIsErrorJustify ? styles.error : ""
            } ${bActiveMaximumInaccuracy && !biologicalVariation ? "" : styles.opacity} `}
            style={{ width: "100%" }}
          >
            <Input
              label={intl.get("justify") + "*"}
              width="100%"
              placeholder={intl.get("ciq.type_here")}
              disabled={!bActiveMaximumInaccuracy || biologicalVariation}
              value={bActiveMaximumInaccuracy && biologicalVariation ? "---" : cJustify}
              onChange={(e) => {
                const value = e.target.value.trim()

                if (!value !== "") {
                  setBIsError({
                    ...bIsError,
                    bIsErrorJustify: false,
                  })
                }

                const newDataConfig = {
                  ...dataConfigAnalyte,
                  eqpanlt_cjustification: value,
                }

                setDataConfigAnalyte(newDataConfig)
                setIsChanged(true)

                setCJustify(e.target.value)
              }}
            />
            <small style={{ color: "red", opacity: bIsError.bIsErrorJustify ? 1 : 0 }}>
              {intl.get("form.required_field")}
            </small>
          </div>
        </div>
      </div>
    </div>
  )
}
